import React from 'react';
import * as styles from './pure-css-sticky-sidebox.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var StickySidebox = _ref => {
  var className = _ref.className,
    _ref$topEdgeOffset = _ref.topEdgeOffset,
    topEdgeOffset = _ref$topEdgeOffset === void 0 ? 0 : _ref$topEdgeOffset,
    children = _ref.children;
  return ___EmotionJSX("div", {
    "data-testid": "sticky-sidebox",
    css: styles.stickyBox(topEdgeOffset)
  }, ___EmotionJSX("div", {
    css: className
  }, children));
};
export default StickySidebox;